module.exports = __webpack_public_path__ + "img/zgjsyh.9770c585.png";